import { Link } from "react-router-dom";
import utilService from "../../../services/general/util.service";
import GalleryImageComponent from "../../elements/GalleryImageComponent";
import MemorialHomePgaeModuleHeaderComponent from "./MemorialHomePgaeModuleHeader";

export const MemorialHomeGalleryComponent = ({ websiteInfo, ...props }) => {
  const { homeGalleryImages } = websiteInfo.deceasedInfo;
  return (
    <section className="gallery_main_content_container">
      <div className="container">
        <div className="home-gallery-container">
          <MemorialHomePgaeModuleHeaderComponent
            baseRoute={websiteInfo.baseRoute}
            title="לראות"
            boldTitle="ולהיזכר"
            route="gallery"
            linkTitle="כל התמונות"
          />

          <div className="gallery_main_content_box">
            <div className="gallery_main_box_left">
              {homeGalleryImages?.length > 0
                ? homeGalleryImages.map((imageDetails) => (
                    <GalleryImageComponent
                      key={utilService.makeId()}
                      url={imageDetails.url}
                    />
                  ))
                : [...Array(3)].map((_) => (
                    <GalleryImageComponent key={utilService.makeId()} />
                  ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MemorialHomeGalleryComponent;
